import { Box } from "@mui/material";

const SectionDivider = () => {
  return (
    <Box
      sx={{
        height: "8px",
        backgroundColor: "#E5E5E5",
        width: "100%",
        borderRadius: "4px",
      }}
    />
  );
};

export default SectionDivider;
